import { IConfigsType } from '../../types'

const bibibopInventory: IConfigsType = {
  bibibop: {
    '/:brand/corporate_inventory': {
      disableAutoMargin: true,
      variables: [
        {
          type: 'bbbCorporateItems',
          dateOptions: {
            types: ['week', 'last_week'],
            endDate: 'yesterday',
          },
        },
        { type: 'inputValue', fields: ['itemSearch'] },
      ],
      dateFilter: {
        types: ['week', 'last_week'],
        endDate: 'yesterday',
      },
      inventoryTitle: {
        type: 'title',
        title: 'Inventory',
      },
      purchaseTitle: {
        type: 'typography',
        apiOrContent: 'Weekly Inventory',
        margin: '52px 0px 0px',
      },
      purchaseCategorySelect: {
        type: 'select',
        value: 'bbbPurchaseCategories.value',
        onChange: 'bbbPurchaseCategories.onChange',
        options: 'bbbPurchaseCategories.options',
        disable: 'bbbPurchaseCategories.disable',
        label: 'Category or Item',
        margin: '65px 0px 25px',
        width: '350px',
        search: true,
      },
      purchaseOppCostTableDownload: {
        type: 'download-csv',
        api: 'bbbCorporatePurchase',
        fileName: 'getexpo-corporate-purchases',
        message: 'Download Table as CSV',
        fields: [
          {
            key: '<%- JSON(allStores?.tableColumns.slice(0, 1)) %>',
            hide: '<%- _.isUndefined(allStores?.tableColumns) %>',
          },
          {
            key: 'netSales',
            title: 'Weekly Net Sales',
            unit: 'dollar',
          },
          {
            key: 'actualUsage',
            title: 'Food and Paper $',
            unit: 'dollar',
          },
          {
            key: 'actualUsagePercent',
            title: 'Food and Paper %',
          },
          {
            key: 'endInventory',
            title: 'Ending Inventory',
            unit: 'dollar',
          },
          {
            key: 'percentOfNetSales',
            title: 'Inventory Level',
          },
        ],
      },
      purchaseOppCostTable: {
        type: 'table-v2',
        api: 'bbbCorporatePurchase',
        pagination: { pageSize: 20 },
        sorting: [
          {
            id: 'netSales',
            desc: true,
          },
        ],
        row: {
          background: '<%- index % 2 ? colors.Porcelain : "" %>',
        },
        columns: [
          {
            key: '<%- JSON(allStores?.tableColumns.slice(0, 1)) %>',
            hide: '<%- _.isUndefined(allStores?.tableColumns) %>',
            width: '350px',
            sortable: true,
          },
          {
            key: 'netSales',
            title: 'Weekly Net Sales',
            align: 'center',
            width: '180px',
            unit: 'dollar',
            sortable: true,
          },
          {
            key: 'actualUsage',
            title: 'Food and Paper $',
            align: 'center',
            width: '150px',
            unit: 'dollar',
            sortable: true,
          },
          {
            key: 'actualUsagePercent',
            title: 'Food and Paper %',
            align: 'center',
            width: '190px',
            decimal: 1,
            sortable: true,
          },
          {
            key: 'endInventory',
            title: 'Ending Inventory',
            align: 'center',
            width: '180px',
            unit: 'dollar',
            sortable: true,
          },
          {
            key: 'percentOfNetSales',
            title: 'Inventory Level',
            align: 'center',
            width: '150px',
            decimal: 0,
            background: {
              range: [0, 1, 2],
              colors: [
                'rgb(222, 157, 155)',
                'rgb(251, 230, 162)',
                'rgb(220, 233, 213)',
              ],
              value: '<%- values?.percentOfNetSalesHeatmap %>',
            },
            sortable: true,
          },
        ],
      },
      trendChart: {
        type: 'line-chart',
        api: 'bbbTrendLocationGroupPurchase',
        margin: '40px 0px 0px',
        width: 1200,
        height: 300,
        label: 'date',
        datasets: [
          {
            key: 'percentOfNetSales',
            label: 'Inventory Level',
          },
          {
            key: 'actualUsagePercent',
            label: 'Food and Paper %',
          },
          {
            key: 'netSales',
            label: 'Weekly Net Sales',
            chartType: 'bar',
            yAxisID: 'y1',
            unit: 'dollar',
          },
          {
            key: 'actualUsage',
            label: 'Food and Paper $',
            chartType: 'bar',
            yAxisID: 'y1',
            unit: 'dollar',
          },
          {
            key: 'endInventory',
            label: 'Ending Inventory',
            chartType: 'bar',
            yAxisID: 'y1',
            unit: 'dollar',
          },
        ],
        scaleTypes: {
          y: {
            type: 'percent',
          },
          y1: {
            type: 'price',
            unit: 'dollar',
          },
        },
        options: {
          scales: {
            y: {
              title: {
                text: '%',
              },
            },
            y1: {
              title: {
                text: '$',
                display: true,
              },
              position: 'right',
              grid: {
                drawOnChartArea: false,
              },
            },
          },
        },
      },
      avtTitle: {
        type: 'typography',
        apiOrContent: 'AvT',
        margin: '52px 0px 0px',
      },
      inventoryCategoryFilter: {
        type: 'grid',
        margin: '25px 0px',
        children: {
          categorySelect: {
            type: 'select',
            value: 'bbbInventoryCategories.value',
            onChange: 'bbbInventoryCategories.onChange',
            options: 'bbbInventoryCategories.options',
            disable: 'bbbInventoryCategories.disable',
            label: 'Category',
          },
          itemSearch: {
            type: 'input',
            value: 'inputValue.itemSearch.value',
            onChange: 'inputValue.itemSearch.onChange',
            label: 'Item',
            placeholder: 'Add ";" to search multiple items',
            width: '325px',
          },
        },
      },
      inventoryOppCostTableDownload: {
        type: 'download-csv',
        api: 'bbbCorporateInventory',
        fileName: 'getexpo-corporate-inventory',
        message: 'Download Table as CSV',
        fields: [
          {
            key: 'itemName',
            title: 'Item',
          },
          {
            key: 'displayParentCategoryName',
            title: 'Category',
          },
          {
            key: 'variancePercent',
            title: 'Total O/S %',
          },
          {
            key: 'variance',
            title: 'Total O/S',
          },
          {
            key: 'varianceSystemwideAvg',
            title: 'System Average',
          },
          {
            key: '<%- JSON(allStoreColumns) %>',
            hide: '<%- _.isUndefined(allStoreColumns)  %>',
          },
        ],
      },
      inventoryOppCostTable: {
        type: 'table-v2',
        api: 'bbbCorporateInventory',
        pagination: { pageSize: 20 },
        row: {
          background: '<%- index % 2 ? colors.Porcelain : "" %>',
        },
        columns: [
          {
            key: 'itemName',
            title: 'Item',
            width: '330px',
            sortable: true,
          },
          {
            key: 'displayParentCategoryName',
            title: 'Category',
            width: '185px',
            sortable: true,
          },
          {
            key: 'variancePercent',
            title: 'Total O/S %',
            align: 'center',
            width: '80px',
            decimal: 1,
            sortable: true,
          },
          {
            key: 'variance',
            title: 'Total O/S',
            align: 'center',
            width: '80px',
            decimal: 2,
            sortable: true,
          },
          {
            key: 'varianceSystemwideAvg',
            title: 'System Average',
            align: 'center',
            width: '80px',
            decimal: 2,
            sortable: true,
          },
          {
            key: '<%- JSON(allStoreColumns) %>',
            hide: '<%- _.isUndefined(allStoreColumns)  %>',
            align: 'center',
            width: '100px',
            decimal: 2,
            sortable: true,
          },
        ],
      },
    },
    '/:brand/inventory': {
      disableAutoMargin: true,
      variables: [
        {
          type: 'bbbLocationItems',
          dateOptions: {
            types: ['week'],
            endDate: 'yesterday',
          },
        },
        { type: 'inputValue', fields: ['itemSearch'] },
      ],
      groupFilter: {
        api: 'locationFilter',
        width: 250,
        autoComplete: true,
      },
      dateFilter: {},
      inventoryTitle: {
        type: 'title',
        title: 'Inventory',
      },
      purchaseTitle: {
        type: 'typography',
        apiOrContent: 'Purchases',
        margin: '52px 0px 0px',
      },
      expoAi: {
        type: 'ai-summary-box',
        api: 'bbbLocationPurchaseAiSummary',
        margin: '40px 0px 0px',
      },
      purchaseByCategoryTitle: {
        type: 'typography',
        apiOrContent: 'Category Usage',
        margin: '52px 0px 0px',
      },
      purchaseByCategory: {
        type: 'table-v2',
        api: 'bbbLocationPurchaseByCategory',
        margin: '25px 0px 0px',
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: 'itemName',
            title: ' ',
          },
          {
            key: 'last4Week',
            title:
              '<%- `Food and Paper % ${date?.getInfo(-4)?.displayName}` %>',
            align: 'center',
            width: '160px',
            decimal: 2,
            background: {
              range: [0, 100],
              colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
              value: '<%- values?.last4WeekHeatMap %>',
            },
          },
          {
            key: 'last3Week',
            title:
              '<%- `Food and Paper % ${date?.getInfo(-3)?.displayName}` %>',
            align: 'center',
            width: '160px',
            decimal: 2,
            background: {
              range: [0, 100],
              colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
              value: '<%- values?.last3WeekHeatMap %>',
            },
          },
          {
            key: 'last2Week',
            title:
              '<%- `Food and Paper % ${date?.getInfo(-2)?.displayName}` %>',
            align: 'center',
            width: '160px',
            decimal: 2,
            background: {
              range: [0, 100],
              colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
              value: '<%- values?.last2WeekHeatMap %>',
            },
          },
          {
            key: 'last1Week',
            title:
              '<%- `Food and Paper % ${date?.getInfo(-1)?.displayName}` %>',
            align: 'center',
            width: '160px',
            decimal: 2,
            background: {
              range: [0, 100],
              colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
              value: '<%- values?.last1WeekHeatMap %>',
            },
          },
          {
            key: 'last0Week',
            title: '<%- `Food and Paper % ${date?.getInfo(0)?.displayName}` %>',
            align: 'center',
            width: '160px',
            decimal: 2,
            background: {
              range: [0, 100],
              colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
              value: '<%- values?.last0WeekHeatMap %>',
            },
          },
        ],
      },
      itemLatestPriceTitle: {
        type: 'typography',
        apiOrContent: 'Key Item Pricing Trend',
        margin: '52px 0px 0px',
      },
      itemLatestPrice: {
        type: 'table-v2',
        api: 'bbbLatestItemPrice',
        margin: '25px 0px 0px',
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: 'name',
            title: 'Item',
          },
          {
            key: 'unitOfMeasureName',
            title: 'Unit of Measure',
          },
          {
            key: 'last2Week',
            title: '<%- `Price ${date?.getInfo(-2)?.displayName}` %>',
            decimal: 2,
            align: 'center',
            background: {
              range: [0, 100],
              colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
              value: '<%- values?.last2WeekHeatMap %>',
            },
          },
          {
            key: 'last1Week',
            title: '<%- `Price ${date?.getInfo(-1)?.displayName}` %>',
            decimal: 2,
            align: 'center',
            background: {
              range: [0, 100],
              colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
              value: '<%- values?.last1WeekHeatMap %>',
            },
          },
          {
            key: 'last0Week',
            title: '<%- `Price ${date?.getInfo(0)?.displayName}` %>',
            decimal: 2,
            align: 'center',
            width: '120px',
            background: {
              range: [0, 100],
              colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
              value: '<%- values?.last0WeekHeatMap %>',
            },
          },
        ],
      },
      weeklyCategorySelectTitle: {
        type: 'typography',
        apiOrContent: 'Inventory Levels',
        margin: '52px 0px 0px',
      },
      weeklyCategorySelect: {
        type: 'select',
        value: 'bbbTrendPurchaseCategories.value',
        onChange: 'bbbTrendPurchaseCategories.onChange',
        options: 'bbbTrendPurchaseCategories.options',
        label: 'Category or Item',
        margin: '25px 0px',
        width: '350px',
        search: true,
      },
      weeklyTable: {
        type: 'table-v2',
        api: 'bbbTrendLocationPurchase',
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: 'date',
            width: '275px',
            useDangerouslySetInnerHTML: true,
          },
          {
            key: 'netSales',
            title: 'Weekly Net Sales',
            align: 'center',
            width: '150px',
            unit: 'dollar',
          },
          {
            key: 'actualUsage',
            title: 'Food and Paper $',
            align: 'center',
            width: '150px',
            unit: 'dollar',
          },
          {
            key: 'actualUsagePercent',
            title: 'Food and Paper %',
            align: 'center',
            width: '180px',
            decimal: 1,
          },
          {
            key: 'endInventory',
            title: 'Ending Inventory',
            align: 'center',
            width: '150px',
            unit: 'dollar',
          },
          {
            key: 'percentOfNetSales',
            title: 'Inventory Level',
            align: 'center',
            width: '180px',
            decimal: 0,
            background: {
              range: [0, 1, 2],
              colors: [
                'rgb(222, 157, 155)',
                'rgb(251, 230, 162)',
                'rgb(220, 233, 213)',
              ],
              value: '<%- values?.percentOfNetSalesHeatmap %>',
            },
          },
        ],
      },
      trendChart: {
        type: 'line-chart',
        api: 'bbbTrendLocationPurchase',
        width: 1100,
        height: 300,
        label: 'date',
        datasets: [
          {
            key: 'percentOfNetSales',
            label: 'Inventory Level',
          },
        ],
        scaleTypes: {
          y: {
            type: 'percent',
          },
        },
        options: {
          scales: {
            y: {
              title: {
                text: '%',
              },
            },
          },
        },
      },
      purchaseWithSpecificItemsTitle: {
        type: 'typography',
        apiOrContent: 'Actual vs Theoretical',
        margin: '52px 0px 0px',
      },
      purchaseWithSpecificItems: {
        type: 'table-v2',
        api: 'bbbLocationPurchaseWithSpecificItems',
        margin: '25px 0px 0px',
        pagination: { pageSize: 20 },
        sorting: [
          {
            id: 'actualCogs',
            desc: true,
          },
        ],
        row: {
          background: '<%- index % 2 ? colors.Porcelain : "" %>',
        },
        columns: [
          {
            key: 'itemName',
            title: 'Item',
            width: '330px',
            sortable: true,
          },
          {
            key: 'displayParentCategoryName',
            title: 'Category',
            width: '185px',
            sortable: true,
          },
          {
            key: 'actualCogs',
            title: 'Actual',
            align: 'center',
            sortable: true,
            unit: 'dollar',
          },
          {
            key: 'idealCogs',
            title: 'Theoretical',
            align: 'center',
            sortable: true,
            unit: 'dollar',
          },
          {
            key: 'cogsVariance',
            title: 'Opportunity Cost',
            align: 'center',
            sortable: true,
            unit: 'dollar',
            decimal: 1,
            background: {
              range: [0, 100],
              colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
              value: '<%- values?.cogsVarianceHeatMap %>',
            },
          },
          {
            key: 'usagePercent',
            title: 'Usage %',
            align: 'center',
            width: '100px',
            sortable: true,
          },
        ],
      },
      purchaseCategoryTitle: {
        type: 'typography',
        apiOrContent: 'Item Usage Detail',
        margin: '52px 0px 0px',
      },
      purchaseCategoryFilter: {
        type: 'grid',
        margin: '25px 0px',
        children: {
          categorySelect: {
            type: 'select',
            value: 'bbbPurchaseCategories.value',
            onChange: 'bbbPurchaseCategories.onChange',
            options: 'bbbPurchaseCategories.options',
            disable: 'bbbPurchaseCategories.disable',
            label: 'Category',
          },
          itemSearch: {
            type: 'input',
            value: 'inputValue.itemSearch.value',
            onChange: 'inputValue.itemSearch.onChange',
            label: 'Item',
            placeholder: 'Add ";" to search multiple items',
            width: '325px',
          },
        },
      },
      purchaseOppCostTableDownload: {
        type: 'download-csv',
        api: 'bbbLocationPurchase',
        fileName: 'getexpo-store-purchases',
        message: 'Download Table as CSV',
        fields: [
          {
            key: 'itemName',
            title: 'Item',
          },
          {
            key: 'unit',
            title: 'Unit',
          },
          {
            key: 'displayParentCategoryName',
            title: 'Category',
          },
          {
            key: 'actualCogs',
            title: 'Actual',
            unit: 'dollar',
          },
          {
            key: 'idealCogs',
            title: 'Theoretical',
            unit: 'dollar',
          },
          {
            key: 'cogsVariance',
            title: 'Opportunity Cost',
            unit: 'dollar',
          },
          {
            key: 'usagePercent',
            title: 'Usage %',
          },
          {
            key: 'usageQty',
            title: 'Usage Qty',
          },
          {
            key: 'endQty',
            title: 'End Inv Qty',
          },
        ],
      },
      purchaseOppCostTable: {
        type: 'table-v2',
        api: 'bbbLocationPurchase',
        pagination: { pageSize: 20 },
        sorting: [
          {
            id: 'actualCogs',
            desc: true,
          },
        ],
        row: {
          background: '<%- index % 2 ? colors.Porcelain : "" %>',
        },
        columns: [
          {
            key: 'itemName',
            title: 'Item',
            width: '330px',
            sortable: true,
          },
          {
            key: 'unit',
            title: 'Unit',
            width: '220px',
            sortable: true,
          },
          {
            key: 'displayParentCategoryName',
            title: 'Category',
            width: '185px',
            sortable: true,
          },
          {
            key: 'actualCogs',
            title: 'Actual',
            align: 'center',
            width: '100px',
            sortable: true,
            unit: 'dollar',
          },
          {
            key: 'usagePercent',
            title: 'Usage %',
            align: 'center',
            width: '100px',
            sortable: true,
          },
          {
            key: 'usageQty',
            title: 'Usage Qty',
            align: 'center',
            width: '110px',
            sortable: true,
          },
          {
            key: 'endQty',
            title: 'End Inv Qty',
            align: 'center',
            width: '130px',
            sortable: true,
          },
        ],
      },
    },
  },
}

export default bibibopInventory
